import { useContext } from 'react';
import ParametersContext from '../contexts/ParametersContext';

const useParametros = () => useContext(ParametersContext);

export default useParametros;
